import RemoveEntityAlert from './RemoveEntityAlert';

export default RemoveEntityAlert;
